export function empty (validate) {

  return (
    (
      typeof validate === 'undefined' ||
      validate === null
    ) ||
    (
      typeof validate === 'string' &&
      (
        validate.trim().length === 0 //||
        //validate.trim().toString() === '0'
      )
    )
  ) ||
  false
}

export function formatDate (date) {
  const d = new Date(date)
  let month = `${  d.getMonth() + 1}`
  let day = `${  d.getDate()}`
  const year = d.getFullYear()

  if (month.length < 2) month = `0${  month}`
  if (day.length < 2) day = `0${  day}`

  return [year, month, day].join('-')
}

export function getExactNumer (percent, max) {
  return percent !== null ? Math.ceil((percent * max) / 100) : null
}

export function getPercent (number, max) {
  return number !== null ? Math.ceil((number * 100) / max) : null
}